import { render, staticRenderFns } from "./editRepayment.vue?vue&type=template&id=5a85cede&scoped=true"
import script from "./editRepayment.vue?vue&type=script&lang=js"
export * from "./editRepayment.vue?vue&type=script&lang=js"
import style0 from "./editRepayment.vue?vue&type=style&index=0&id=5a85cede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a85cede",
  null
  
)

export default component.exports